import {
    React,Component,BootstrapTable,
    paginationFactory,Button, ButtonToolbar, Card, 
    Form, Col, Row, axios, Typeahead, TimePicker,
    cellEditFactory ,moment, NavLink, Alert, AppConfiguration,
    NoserLoading, Noser, Banner, Container, DatePicker,  Tabs, Tab,
    sizePerPageRenderer,Type
} 
from '../../noser-hris-component';


class DeductionSummary extends Component {
    constructor(props) {
        super(props)
        this.state = {
            userinfo        :   [],
            isloading       :   false,
            isshow          :   false,
            alerttype       :   "",
            message         :   "",
            color           :   "",
            fade            :   true,

            clientId        :   "",
            clientName      :   "",
            employeeId      :   "",
            employeeName    :   "",
            payperiodId     :   "",
            payperiod       :   "",
            payrollDate     :   "",
            
            clientDDL       :   [],
            periodDDL       :   [],
            employeeDDL     :   [],
            deductionGRID   :   [],
            yesnoDDL        :   [
                {
                    "value":"0",
                    "label":"YES"
                },
                {
                    "value":"1",
                    "label":"NO"
                }
            ]
        }
    }
    GetRequest = async(props) => {
        let response = {
            "status" : "",
            "message" : "",
            [props.params._collection]:[]
        }
        let collection = new Array()
        await axios
        .post(props.url , props.params)
        .then(res => {
                const data = res.data
                data[props.params._collection].map(function(itm,i){
                    let strJson = "{" + "'id':" + itm.substring(17, 43) + "," + itm.substring(46, itm.length)
                    let json = JSON.parse(strJson.replace(/'/g,'"'));
                    collection.push(json)
                })
                response = {
                    status : "1",
                    "message" : "success",
                    [props.params._collection]:collection
                }
        })
        .catch(error=>{
            response = {
                status : "0",
                "message" : "An error occured while processing your request, Please contact your System Administrator for : " + error.message,
                [props.params._collection]:[]
            }
        })
        return response
    } 
    PostRequest = async(props) => {
        let response = {
            "status" : "",
            "message" : ""
        }
        let collection = new Array()
        await axios
        .post(props.uri , props.params)
        .then(res => {
                //const data = res.data
                response = {
                    status : "1",
                    "message" : "success"
                }
        })
        .catch(error=>{
            response = {
                status : "0",
                "message" : "An error occured while processing your request, Please contact your System Administrator for : " + error.message
            }
        })
        return response
    } 
    componentDidMount(){
        this.state.userinfo = JSON.parse(sessionStorage.getItem("userData"))
        this.GetClients()
    }
    GetClients = async()=> {
        this.setState({isloading:true,})
        const clientParams = {
            "IpAddress":"0.0.0.0",
            "ClientId":this.state.userinfo.clientId,
            "UserId":this.state.userinfo.userId,
       }
       await axios
           .post(
               AppConfiguration.Setting().noserapiendpoint + "Client/GetClientList", clientParams
           )
           .then(res => {
               const data = res.data;
               this.setState({clientDDL: data.clients, isloading:false})
           })
           .catch(error=>{
            this.setState({
                isloading   :   false,
                alerttype   :   "Error!",
                isshow      :   true,
                color       :   "danger",
                message     :   "An error occured while processing your request, Please contact your System Administrator for : " + error.message,
                fade        :   true
            })
        })
    }
    GetEmployeeList = async() =>{
        this.setState({isloading:true})
        
        const params = {
            "IpAddress":"0.0.0.0",
            "ClientId":this.state.clientId,
            "UserId":this.state.userinfo.userId,
        }
        await axios
        .post(AppConfiguration.Setting().noserapiendpoint + "Employee/GetEmployeeProfileFilter", params)
        .then(res => {
            const data = res.data;
            this.setState({employeeDDL : data.profiles.filter(x=>x.status==="ACTIVE"),isloading:false})
        })
        .catch(error=>{
            this.setState({
                isloading   :   false,
                alerttype   :   "Error!",
                isshow      :   true,
                color       :   "danger",
                message     :   "An error occured while processing your request, Please contact your System Administrator for : " + error.message,
                fade        :   true
            })
        })
    }
    GetPayPeriodList = async(isSpecial) => {
        let payrollperiods = []
        const params = {
            "IpAddress":"0.0.0.0",
            "ClientId":this.state.clientId,
            "UserId":this.state.userinfo.userId,
            "IsProcessed": "1"
         };
         let api = ""
         if(isSpecial==="0"){
            api = "Timekeeping/GetPayrollPeriods"
         }
         else{
            api = "Timekeeping/GetSpecialPayrollPeriods"
         }
         //console.log(params)
        await axios
            .post(
                AppConfiguration.Setting().noserapiendpoint + api,  params
            )
            .then(res => {
                const data = res.data;
                //this.setState({periodDDL: data.payrollPeriods })
                //console.log(data)
                data.payrollPeriods.map(function(itm){
                    payrollperiods.push(
                        {
                            "typeId":itm.typeId,
                            "periodId":itm.periodId,
                            "payPeriod":itm.payPeriod,
                            "startDate":itm.startDate,
                            "endDate":itm.endDate
                        }
                    )
                })
            })
            .catch(error=>{
                this.setState({
                    isloading   :   false,
                    alerttype   :   "Error!",
                    isshow      :   true,
                    color       :   "danger",
                    message     :   "An error occured while processing your request, Please contact your System Administrator for : " + error.message,
                    fade        :   true
                })
            })

        /*PROCESSED PAYROLL*/
        const params1 = {
            "IpAddress":"0.0.0.0",
            "ClientId":this.state.clientId,
            "UserId":this.state.userinfo.userId,
            "EmployeeId": this.state.employeeId
         };
         
         if(isSpecial==="0"){
            api = "Timekeeping/GetPayrollPeriods"
         }
         else{
            api = "Timekeeping/GetSpecialPayrollPeriods"
         }
         //console.log(params)
        await axios
            .post(
                AppConfiguration.Setting().noserapiendpoint + api,  params1
            )
            .then(res => {
                const data1 = res.data;
                //this.setState({periodDDL: data.payrollPeriods })
                data1.payrollPeriods.map(function(itm){
                    payrollperiods.push(
                        {
                            "typeId":itm.typeId,
                            "periodId":itm.periodId,
                            "payPeriod":itm.payPeriod,
                            "startDate":itm.startDate,
                            "endDate":itm.endDate
                        }
                    )
                })
            })
            .catch(error=>{
                this.setState({
                    isloading   :   false,
                    alerttype   :   "Error!",
                    isshow      :   true,
                    color       :   "danger",
                    message     :   "An error occured while processing your request, Please contact your System Administrator for : " + error.message,
                    fade        :   true
                })
            })
        //console.log(payrollperiods)  
        this.setState({periodDDL: payrollperiods })  
    }
    handleChangedClient = (e) =>{
        this.state.alerttype="";this.state.isshow=false;this.state.color="";this.state.message="";this.state.fade=true;this.state.isloading=false
        if(e.length===0) {
            this.state.clientId = ""
            this.state.clientName = ""
            this.state.employeeDDL=[]
            return
        }
        this.state.clientId = e[0].id
        this.state.clientName = e[0].name
        this.GetPayPeriodList(e[0].isSpecial)
    }
    handleChangedEmployee = (e) =>{
        this.state.alerttype="";this.state.isshow=false;this.state.color="";this.state.message="";this.state.fade=true;this.state.isloading=false
        if(e.length===0) {
            this.state.employeeId = ""
            this.state.employeeName=[]
            return
        }
        this.state.employeeId = e[0].id
    }
    handleChangedPeriod = (e) =>{
        this.state.alerttype="";this.state.isshow=false;this.state.color="";this.state.message="";this.state.fade=true;this.state.isloading=false
        if(e.length===0) {
            this.state.payperiodId = ""
            this.state.payperiod= ""
            this.state.payrollDate= ""
            return
        }
        this.state.payperiodId = e[0].periodId
        this.state.payrollDate = e[0].endDate
        this.state.payperiod = e[0].payPeriod
        
    }
    handleSearchClick = async()=>{
        this.setState({isloading:true,})
        if(this.state.clientId===""){
            this.setState({
                isloading   :   false,
                alerttype   :   "Error!",
                isshow      :   true,
                color       :   "danger",
                message     :   "Please select client.",
                fade        :   true
            })
            return 
        }
        if(this.state.payperiodId===""){
            this.setState({
                isloading   :   false,
                alerttype   :   "Error!",
                isshow      :   true,
                color       :   "danger",
                message     :   "Please select cut-off.",
                fade        :   true
            })
            return 
        }
        const params = {
            "IpAddress":"0.0.0.0",
            "ClientId":this.state.clientId,
            "UserId":this.state.userinfo.userId,
            "PayPeriodId":this.state.payperiodId,
            //"IsPosted":"1"
        }
        //console.log(params)
        await axios
        .post(AppConfiguration.Setting().noserapiendpoint + "PayrollConfiguration/GetDeductionSummary", params)
        .then(res => {
            const data = res.data;
            if(data.status==="0"){
                this.setState({
                    isloading   :   false,
                    alerttype   :   "Error!",
                    isshow      :   true,
                    color       :   "danger",
                    message     :   data.message,
                    fade        :   true
                })
                return
            }
            this.setState({deductionGRID : data.deductionSummaries,isloading:false})
        })
        .catch(error=>{
            this.setState({
                isloading   :   false,
                alerttype   :   "Error!",
                isshow      :   true,
                color       :   "danger",
                message     :   "An error occured while processing your request, Please contact your System Administrator for : " + error.message,
                fade        :   true
            })
        })
    }
    handleGetLatest = async() => {
        // this.setState({isloading:true,})
        // if(this.state.clientId===""){
        //     this.setState({
        //         isloading   :   false,
        //         alerttype   :   "Error!",
        //         isshow      :   true,
        //         color       :   "danger",
        //         message     :   "Please select client.",
        //         fade        :   true
        //     })
        //     return 
        // }
        // if(this.state.payperiodId===""){
        //     this.setState({
        //         isloading   :   false,
        //         alerttype   :   "Error!",
        //         isshow      :   true,
        //         color       :   "danger",
        //         message     :   "Please select cut-off.",
        //         fade        :   true
        //     })
        //     return 
        // }

        // let filter_data = {"isDeleted": "0", "isPosted": "0","hrisId":"1","client": this.state.clientName}
        // console.log(filter_data)
        // let resp = await GetRequest(
        //         {
        //             url : AppConfiguration.Setting().noserareapi + "action/get",
        //             params : {
        //                     "_collection" : "DeductionSummaryDetails",
        //                     "filter_data" : filter_data
        //                     }    
        //         })
        //         //console.log("are response")
        //         console.log(resp)
        // if(resp.status==="1"){
        //     //console.log(resp.DeductionSummaryDetails)
        //     //console.log(this.state.payrollDate)
        //     let deductionGRID = resp.DeductionSummaryDetails.filter(x=>x.client===this.state.clientName && x.payrollDate===this.state.payrollDate)
        //     //console.log(deductionGRID)
        //     deductionGRID.map(function(itm,idx){
        //         itm.payrollAmount = itm.payrollAmount.toString()
        //     })
        //     this.setState({deductionGRID:deductionGRID})
        //     if(deductionGRID.length==0){
        //         this.setState({
        //             isloading   :   false,
        //             alerttype   :   "Information!",
        //             isshow      :   true,
        //             color       :   "info",
        //             message     :   "No record found in AR E for the payroll period of " + this.state.payperiod,
        //             fade        :   true
        //         })
        //     }
        // }
        // else{
        //     this.setState({
        //         isloading   :   false,
        //         alerttype   :   "Information!",
        //         isshow      :   true,
        //         color       :   "info",
        //         message     :   "No record found in AR E for the payroll period of " + this.state.payperiod,
        //         fade        :   true
        //     })
        // }
        // this.setState({isloading:false})
    }
    handleSaveClick = async()=>{
        this.setState({isloading:true,})
        if(this.state.clientId===""){
            this.setState({
                isloading   :   false,
                alerttype   :   "Error!",
                isshow      :   true,
                color       :   "danger",
                message     :   "Please select client.",
                fade        :   true
            })
            return 
        }
        if(this.state.payperiodId===""){
            this.setState({
                isloading   :   false,
                alerttype   :   "Error!",
                isshow      :   true,
                color       :   "danger",
                message     :   "Please select cut-off.",
                fade        :   true
            })
            return 
        }
        if(this.state.deductionGRID.length===0){
            this.setState({
                isloading   :   false,
                alerttype   :   "Error!",
                isshow      :   true,
                color       :   "danger",
                message     :   "No deduction summary to save.",
                fade        :   true
            })
            return 
        }

        const params = {
            "IpAddress":"0.0.0.0",
            "ClientId":this.state.clientId,
            "UserId":this.state.userinfo.userId,
            "PayPeriodId":this.state.payperiodId,
            "deductionSummaries":this.state.deductionGRID.filter(x=>x.isPosted==="0")
        }
        //console.log(params)
        await axios
        .post(AppConfiguration.Setting().noserapiendpoint + "PayrollConfiguration/SaveDeductionSummary", params)
        .then(res => {
            const data = res.data;
            
            this.setState({
                isloading   :   false,
                alerttype   :   data.status==="1" ? "Success!" : "Error!",
                isshow      :   true,
                color       :   data.status==="1" ? "success" : "danger",
                message     :   data.message,
                fade        :   true
            })
        })
        .catch(error=>{
            this.setState({
                isloading   :   false,
                alerttype   :   "Error!",
                isshow      :   true,
                color       :   "danger",
                message     :   "An error occured while processing your request, Please contact your System Administrator for : " + error.message,
                fade        :   true
            })
        })
    }
    GridDataModified(oldValue, newValue, rowid, column) {
        let isDisable = true
        this.state.deductionGRID.map(function(item,i){
            if(item.id===rowid && item.isPosted==="1"){
                alert("Transaction is already posted")
                item.payrollAmount = oldValue
                return
            }
            if(item.id===rowid){
                item.isModified = "1"
            }
            if(item.isModified=="1"){
                isDisable = false
            }
        })
        this.setState({disableSaveBtn:isDisable})
    }
    IsDecimal(val)
    {
        var regex = /^\d*\.?(?:\d{1,2})?$/;
        return !regex.test(val)
    }
    render() {
        const deductionCol =[
            {
                dataField: 'employeeNo',
                text: 'EMPLOYEE NO',
                editable: false,
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center',width:'10%' }},
                style:{textAlign:'center',width:'10%'}
            },
            {
                dataField: 'employeeName',
                text: 'EMPLOYEE NAME',
                editable: false,
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'left',width:'15%' }},
                style:{textAlign:'left',width:'15%'}
            },
            {
                dataField: 'deductionName',
                text: 'DEDUCTION NAME',
                editable: false,
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'left',width:'20%' }},
                style:{textAlign:'left',width:'20%'}
            },
            {
                dataField: 'payrollDate',
                text: 'PAYROLL DATE',
                editable: false,
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center',width:'10%' }},
                style:{textAlign:'center',width:'10%'}
            },
            {
                dataField: 'payrollAmount',
                text: 'DEDUCTION AMOUNT',
                editable: true,
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center',width:'10%' }},
                style:{textAlign:'right',width:'10%'},
                validator: (newValue, row, column) => {
                    
                    if (this.IsDecimal(newValue)) {
                      return {
                        valid: false
                      };
                    }
                    if(newValue.split(".").length>2)
                    return {
                        valid: false
                      };
                    return true;
                }
            },
            {
                dataField: 'isDeleted',
                text: 'FOR PAYROLL PROCESS',
                editable: false,
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'left',width:'45%' }},
                style:{textAlign:'left',width:'45%'},
                editor: {
                    type: Type.SELECT,
                    options: this.state.yesnoDDL
                  },
                  formatter: (cell, row) => {
                      if(row.isDeleted!='' && row.isDeleted!=null){
                          return this.state.yesnoDDL.find(x => x.value == cell).label;
                      }
                  }
            }
        ]
        const selectRow = {
            mode: 'checkbox',
            hideSelectAll: true,
            clickToSelectAndEditCell: true,
            onSelect: (row, isSelect, rowIndex, e) => {
                this.state.deductionGRID.map(function(itm,idx){
                    if(itm.id===row.id && itm.isPosted==="1"){
                        alert("Transaction is already posted")
                        itm.isDeleted = "0"
                        return
                    }
                    if(itm.id===row.id){
                        itm.isDeleted = isSelect ? "1" : "0"
                    }
                })
            }
        };
        const rowClasses = (row, rowIndex) => {
        let classes = null;
        console.log(row)
        if (row.isPosted==="1") {
            classes = 'noser-table-row-class no-checkbox';
        }
        else{
            classes = 'noser-table-row-class';
        }
        return classes;
        };
        return(
            <div>
            <Banner />
            <Container className="themed-container" fluid={true}>
                <Card className="mt-5">
                    <Card.Header>PAYROLL >> DEDUCTION SUMMARY </Card.Header>
                    <Card.Body>
                        <Form>
                            <Alert isOpen={this.state.isshow} color={this.state.color} fade={this.state.fade} className={this.state.isshow ? 'display-block' : 'display-none'}>
                                <div className={this.state.color}></div> 
                                {this.state.message}
                            </Alert>
                            <Form.Group as={Row} controlId="formHorizontalEmail">
                                <Col sm={12}>
                                    <Typeahead
                                        labelKey='name'
                                        id="basic-example"
                                        onChange={this.handleChangedClient}
                                        options={this.state.clientDDL}
                                        placeholder="Select Client"
                                    />
                                </Col>
                            </Form.Group>
                            {/* <Form.Group as={Row} controlId="formHorizontalEmail">
                                <Col sm={12}>
                                    <Typeahead
                                        labelKey='employeeName'
                                        id="basic-example"
                                        onChange={this.handleChangedEmployee}
                                        options={this.state.employeeDDL}
                                        placeholder="Select Employee"
                                    />
                                </Col>
                            </Form.Group> */}
                            <Form.Group as={Row} controlId="formHorizontalEmail">
                                <Col sm={12}>
                                    <Typeahead
                                        labelKey='payPeriod'
                                        id="basic-example"
                                        onChange={this.handleChangedPeriod}
                                        options={this.state.periodDDL}
                                        placeholder="Select Cut-Off"
                                    />
                                </Col>
                            </Form.Group>
                            <ButtonToolbar className="mt-1">
                                <Button variant="primary" className="ml-auto noser-button" onClick={ this.handleSearchClick }>Search</Button>
                            </ButtonToolbar>
                            <Form.Group as={Row} controlId="formHorizontalEmail"  className="mt-2">
                                <Col sm={12}>
                                <Card.Header>DEDUCTION SUMMARY LIST</Card.Header>
                                <div>
                                    <BootstrapTable
                                        keyField = "id"
                                        data = { this.state.deductionGRID }
                                        columns = { deductionCol }
                                        selectRow = { selectRow }
                                        cellEdit = { cellEditFactory({ 
                                                mode: 'dbclick', 
                                                blurToSave: true,
                                                afterSaveCell: (oldValue, newValue, row, column) => { 
                                                    this.GridDataModified(oldValue, newValue, row.id, column.dataField)
                                                }
                                            })
                                        }
                                        rowClasses="noser-table-row-class"
                                        striped
                                        hover
                                        condensed
                                        loading={true}
                                        wrapperClasses="table-responsive"
                                        pagination={ paginationFactory({sizePerPageRenderer})}
                                        noDataIndication={ () => <div style={{width:'100%'}}>No record found.</div> }
                                        //rowStyle={ rowStyle }
                                        rowClasses={ rowClasses }
                                    />
                                </div>
                                </Col>
                            </Form.Group>
                            <ButtonToolbar className="mt-1">
                                <Button variant="primary" className="noser-button" onClick={this.handleGetLatest}>Update From AR E</Button>
                                <Button variant="success" className="noser-button ml-auto" onClick={this.handleSaveClick}>SAVE</Button>
                            </ButtonToolbar>
                        </Form>
                    </Card.Body>
                </Card>
            </Container>
            <NoserLoading show={this.state.isloading} />
            </div>
        )
    }
}
export  default DeductionSummary
